var spinner = {
	init: function() {
		var maxtimeSpinnerFst = 17; /* pocet sekund animace */
		var iSpinnerFst = 0;

		var timerSpinnerFst=function(){  
		    var count = ++iSpinnerFst;
		    if(count==maxtimeSpinnerFst+1) {iSpinnerFst = 0; count = 0;};

			if ( $( '#js-spinner-1' ).length > 0 ) {
		    	document.getElementById("js-spinner-1").className="spinner s"+count;
			}
		}

		setInterval(timerSpinnerFst, 1000);

		var maxtimeSpinnerSnd = 17; /* pocet sekund animace */
		var iSpinnerSnd = 0;

		var timerSpinnerSnd=function(){  
		    var count = ++iSpinnerSnd;
		    if(count==maxtimeSpinnerSnd+1) {iSpinnerSnd = 0; count = 0;};

		    if ( $( '#js-spinner-2' ).length > 0 ) {
		    	document.getElementById("js-spinner-2").className="spinner s"+count;
		    }
		}

		setInterval(timerSpinnerSnd, 1000);
	}
}

export {
	spinner
};